import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../../../../../../Control/Checkbox/index.js';
import { Checkbox } from '../../../../../../Control/Checkbox/Checkbox.js';

var MultipleSelectionListItem = /*#__PURE__*/React.memo(/*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    listItemProps = props.listItemProps,
    isSelected = props.isSelected,
    isDisabled = props.isDisabled;
  return /*#__PURE__*/React.createElement("li", _extends({}, listItemProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(Checkbox, {
    selection: isSelected ? 'selected' : 'unselected',
    state: isDisabled ? 'disabled' : 'enabled',
    decorative: true
  }), children);
}));

export { MultipleSelectionListItem };
//# sourceMappingURL=MultipleSelectionListItem.js.map
